import { Button } from '~/components/button'
import { Link } from '~/components/link'
import { type ScopedProps, useSnackbarContext } from '../../snackbar'
import * as Comp from './footer.styles'

type FooterProps = {
  testID?: string
}

export function Footer(props: FooterProps) {
  const { __scopeSnackbar, testID } = props as ScopedProps<FooterProps>

  const { layout, withIcon, buttonLabel, onPressFooterButton } =
    useSnackbarContext('Footer', __scopeSnackbar)

  if (layout === 'with-link') {
    return (
      <Comp.Root withIcon={withIcon} isLink testID={testID}>
        <Link.Root size="ml" icon={false} onPress={onPressFooterButton}>
          <Link.Label>{buttonLabel}</Link.Label>
        </Link.Root>
      </Comp.Root>
    )
  }

  return (
    <Comp.Root withIcon={withIcon} testID={testID}>
      <Button.Root
        size="ml"
        variant="neutral-secondary"
        onPress={onPressFooterButton}
      >
        <Button.Label>{buttonLabel}</Button.Label>
      </Button.Root>
    </Comp.Root>
  )
}
